import { hy } from "./hy";
import { en } from "./en";
import { ru } from "./ru";

export const translations = {
    hy,
    en,
    ru
};

export const LANGUAGES = [
    { code: "hy", label: "ՀԱՅ", flag: "/flags/armenia.png", title: "Հայերեն" },
    { code: "en", label: "ENG", flag: "/flags/united-kingdom.png", title: "English" },
    { code: "ru", label: "РУС", flag: "/flags/russia.png", title: "Русский" },
];
